import * as searchSelectors from '~/domains/search/selectors';

export default (state) => {
  const isANGSearchEnabled = searchSelectors.isANGSearchEnabled(state);

  return { searchExperience: isANGSearchEnabled ? 'ang' : 'exchange' };
};
